import { render } from "./ProductPromotion.vue?vue&type=template&id=1689ea08&scoped=true"
import script from "./ProductPromotion.vue?vue&type=script&lang=ts"
export * from "./ProductPromotion.vue?vue&type=script&lang=ts"

import "./ProductPromotion.vue?vue&type=style&index=0&id=1689ea08&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1689ea08"

export default script